<template>
  <b-card>
    <b-form v-on:submit.prevent enctype="multipart/form-data">
      <b-row>
        <b-col md="3">
          <b-form-group label="Code" label-for="code">
            <b-form-input
              id="code"
              placeholder="Code"
              v-model="form.code"
              required
            />
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Account From" label-for="account_from">
            <v-select
              id="account_from"
              v-model="form.selectedAccountFrom"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="text"
              :options="form.optionsAccountFrom"
              placeholder="Select 1 Account From"
            >
              <template #search="{ attributes, events }">
                <input
                  class="vs__search"
                  :required="!form.selectedAccountFrom"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
            <!-- Selected: <strong>{{ form.selectedAccountFrom }}</strong> -->
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Account To" label-for="account_to">
            <v-select
              id="account_to"
              v-model="form.selectedAccountTo"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="text"
              :options="form.optionsAccountTo"
              placeholder="Select 1 Account To"
            >
              <template #search="{ attributes, events }">
                <input
                  class="vs__search"
                  :required="!form.selectedAccountTo"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
            <!-- Selected: <strong>{{ form.selectedAccountTo }}</strong> -->
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <b-form-group label="Description" label-for="description">
            <b-form-textarea
              id="description"
              placeholder="Description"
              v-model="form.description"
              required
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3">
          <b-form-group label="Date" label-for="date">
            <flat-pickr
              id="date"
              v-model="form.date"
              class="form-control"
              placeholder="Date"
              :config="{ dateFormat: 'd-m-Y' }"
            />
            <!-- <p>Value: '{{ form.date }}'</p> -->
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Amount" label-for="amount">
            <cleave
              id="amount"
              placeholder="Amount"
              v-model="form.amount"
              class="form-control"
              :raw="false"
              :options="options.number"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <!-- submit and reset -->
        <b-col md="12" class="mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            @click="validation()"
          >
            Submit
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BFormTextarea,
  BDropdownItem,
  BDropdown,
  BBadge,
  BPagination,
  BFormFile,
  BImg,
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ImageUploader from "vue-image-upload-resize";
import { $themeConfig } from "@themeConfig";
import Cleave from "vue-cleave-component";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    flatPickr,
    VueGoodTable,
    ToastificationContent,
    vSelect,
    ImageUploader,
    Cleave,
    BFormTextarea,
    BPagination,
    BBadge,
    BDropdownItem,
    BDropdown,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BImg,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    Prism,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form: {
        code: "",
        selectedAccountFrom: null,
        optionsAccountFrom: [],
        selectedAccountTo: null,
        optionsAccountTo: [],
        description: "",
        date: null,
        amount: null,
      },
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
        },
      },
      errors: "",
      errMessage: "",
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        1: "light-success",
        0: "light-danger",
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  setup() {
    // App Name
    const { baseUrl, apiUrl } = $themeConfig.app;
    return {
      baseUrl,
      apiUrl,
    };
  },
  created() {
    this.getAccounts();
  },
  methods: {
    getAccounts() {
      this.$http.get("finance/accounts").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          var $data = {
            value: datas[i].id,
            text: datas[i].name,
          };
          // console.log($data)
          this.form.optionsAccountFrom.push($data);
          this.form.optionsAccountTo.push($data);
        }
        // console.log(this.form.optionsAccountFrom)
      });
    },
    validation() {
      if (this.form.code === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Code field is required",
            variant: "warning",
          },
        });
      } else if (this.form.selectedAccountFrom === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Account From field is required",
            variant: "warning",
          },
        });
      } else if (this.form.selectedAccountTo === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Account To field is required",
            variant: "warning",
          },
        });
      } else if (this.form.description === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Description field is required",
            variant: "warning",
          },
        });
      } else if (this.form.date === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Date field is required",
            variant: "warning",
          },
        });
      } else if (this.form.amount === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Amount field is required",
            variant: "warning",
          },
        });
      } else {
        this.addTransfer();
      }
    },
    addTransfer() {
      if (this.form.selectedAccountFrom !== null) {
        var $accountFromID = this.form.selectedAccountFrom.value;
      }
      if (this.form.selectedAccountTo !== null) {
        var $accountToID = this.form.selectedAccountTo.value;
      }
      var newAmount = this.form.amount;
      newAmount = newAmount.replace(/\,/g, "");
      this.$http
        .post("finance/transfer/add", {
          code: this.form.code,
          account_from: $accountFromID,
          account_to: $accountToID,
          description: this.form.description,
          date: this.form.date,
          amount: newAmount,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Success add Transfer",
              variant: "success",
            },
          });
          location.href = "/finance/finance-transfer";
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>